export default "__VITE_ASSET__gZUs2q6m__"